import axios from '../../config/axios';

function create(data) {
    return axios().post("/sales/sales-people", data, {
        headers: {
            Dpk: data.dpk
        }
    });
}

function get(id) {
    return axios().get(`/sales/sales-people/${id}`);
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get(`/sales/sales-people`, {
        params
    })
}

function update(id, data) {
    return axios().put(`/sales/sales-people/${id}`, data)
}

function destroy(id) {
    return axios().delete(`/sales/sales-people/${id}`);
}

function search(query) {
    return axios().get("/sales/sales-people-search", {
        params: {
            search: query
        }
    })
}

export default {
    create,
    get,
    index,
    update,
    destroy,
    search
}